import { useState, useRef, useEffect } from 'react'
import { useTheme } from '../../context/ThemeContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun, faMoon, faWater } from '@fortawesome/free-solid-svg-icons'
import './index.scss'

const THEMES = [
  {
    key: 'dark',
    label: 'Dark',
    icon: faMoon,
    swatch: ['#022c43', '#ffd700'],
  },
  {
    key: 'light',
    label: 'Light',
    icon: faSun,
    swatch: ['#f0ece4', '#c9910a'],
  },
  {
    key: 'ocean',
    label: 'Ocean',
    icon: faWater,
    swatch: ['#04080f', '#06b6d4'],
  },
]

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()
  const [open, setOpen] = useState(false)
  const wrapRef = useRef(null)

  // Close on outside click
  useEffect(() => {
    if (!open) return
    const handler = (e) => {
      if (!wrapRef.current?.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [open])

  const handleSelect = (_e, key) => {
    const rect = wrapRef.current.getBoundingClientRect()
    toggleTheme(
      rect.left + rect.width  / 2,
      rect.top  + rect.height / 2,
      key,
    )
    setOpen(false)
  }

  return (
    <div className="theme-switcher" ref={wrapRef}>
      {/* Toggle button — shows current theme icon */}
      <button
        className={`theme-toggle ${open ? 'theme-toggle--open' : ''}`}
        onClick={() => setOpen((v) => !v)}
        title="Change theme"
        aria-label="Change theme"
        aria-expanded={open}
        aria-haspopup="true"
      >
        {THEMES.map(({ key, icon }) => (
          <span key={key} className={`toggle-icon ${theme === key ? 'active' : ''}`}>
            <FontAwesomeIcon icon={icon} />
          </span>
        ))}
      </button>

      {/* Popover */}
      {open && (
        <div className="theme-popover" role="menu">
          <p className="theme-popover__label">Theme</p>
          {THEMES.map(({ key, label, icon, swatch }) => (
            <button
              key={key}
              className={`theme-option ${theme === key ? 'theme-option--active' : ''}`}
              onClick={(e) => handleSelect(e, key)}
              role="menuitem"
            >
              {/* Mini colour preview */}
              <span className="theme-option__swatch">
                <span style={{ background: swatch[0] }} />
                <span style={{ background: swatch[1] }} />
              </span>

              <FontAwesomeIcon className="theme-option__icon" icon={icon} />

              <span className="theme-option__name">{label}</span>

              {theme === key && <span className="theme-option__check">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default ThemeToggle
